let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8Nwte")).then(() => parcelRequire('5Mya4'));